// extracted by mini-css-extract-plugin
export var $animation_name = "Image-module--$animation_name--ccd47";
export var CaptionWrapper = "Image-module--CaptionWrapper--227b9";
export var Image = "Image-module--Image--555f4";
export var Image___loaded = "Image-module--Image___loaded--766bc";
export var Image__wrapper = "Image-module--Image__wrapper--45052";